import React from 'react';
import Img from 'react-image/cjs';

import arrayUtils from '../../utils/arrayUtils';

const AppImage = ({src, alt = '', ...restProps}) => {
    const srcSet = arrayUtils.toArray(src);

    return <Img alt={alt} {...restProps} src={srcSet} />;
};

export default AppImage;
